import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import useFormatDate from '../../current-locale/use-format-date'
import { CoreErrorCode, CoreErrorDetails } from '../error-handler.backend-types'
import { getBadParameterMessage } from './bad-parameter'
import { getBillNotFoundMessage } from './bill-not-found'
import { getInvalidEntityMessage } from './invalid-entity'
import { getOverbookingNotAllowedMessage } from './overbooking-not-allowed'
import { getResourceNotAvailableMessage } from './resource-not-available'

export function useCoreErrorMessage() {
  const { t } = useTranslation()
  const formatDate = useFormatDate()

  const getCoreErrorMessage = useCallback(
    function getCoreErrorMessage<N extends CoreErrorCode>(code: N, details?: unknown): string | null {
      try {
        switch (code) {
          case CoreErrorCode.BAD_PARAMETER:
            return getBadParameterMessage(t, details as CoreErrorDetails<'BAD_PARAMETER'>)
          case CoreErrorCode.BILL_NOT_FOUND:
            return getBillNotFoundMessage(t, details as CoreErrorDetails<'BILL_NOT_FOUND'>)
          case CoreErrorCode.CONFIGURATION_KEY:
            return null
          case CoreErrorCode.COUNTER_ALREADY_EXISTS:
            return null
          case CoreErrorCode.COUNTER_NOT_FOUND:
            return null
          case CoreErrorCode.DAILY_AVAILABILITY_NOT_FOUND:
            return null
          case CoreErrorCode.ENTITY_NOT_FOUND:
            return null
          case CoreErrorCode.ENTITY_REFERENCE:
            return null
          case CoreErrorCode.EXTERNAL_SERVICE:
            return null
          case CoreErrorCode.FAKE_ERROR:
            return null
          case CoreErrorCode.FISCAL_GATEWAY_BAD_REQUEST:
            return null
          case CoreErrorCode.GENERIC:
            return null
          case CoreErrorCode.INVALID_DOCUMENT:
            return null
          case CoreErrorCode.INVALID_ENTITY:
            return getInvalidEntityMessage(t, details as CoreErrorDetails<'INVALID_ENTITY'>)
          case CoreErrorCode.INVALID_OPERATION:
            return null
          case CoreErrorCode.INVALID_PLACEHOLDER_FORMAT:
            return null
          case CoreErrorCode.MISSING_ONEPLATFORM_CREDENTIALS:
            return null
          case CoreErrorCode.MISSING_ONEPLATFORM_REGISTRY_COMPANY_UUID:
            return null
          case CoreErrorCode.OTA_CONFIGURATION:
            return null
          case CoreErrorCode.OVERBOOKING_NOT_ALLOWED:
            return t('pms.core_error.overbooking_not_allowed') //getOverbookingNotAllowedMessage(t, formatDate, details as CoreErrorDetails<'OVERBOOKING_NOT_ALLOWED'>)
          case CoreErrorCode.RESOURCE_NOT_AVAILABLE:
            return getResourceNotAvailableMessage(t, formatDate, details as CoreErrorDetails<'RESOURCE_NOT_AVAILABLE'>)
          case CoreErrorCode.TSPAY_ERROR:
            return null
          case CoreErrorCode.CLOSED_BILL:
            return t('pms.core_error.closed_bills')
          case CoreErrorCode.HORECAHUB_INTEGRATION_NOT_REGISTERED_FOR_PRODUCT:
            return null
          case CoreErrorCode.RESOURCETYPE_INVENTORY_OVERFLOW:
            return null
        }
        return checkSwitchExhaustive(code)
      } catch (error) {
        return null
      }
    },
    [t, formatDate],
  )

  return getCoreErrorMessage
}

function checkSwitchExhaustive(x: never): never {
  throw new Error('Switch not exhaustive')
}
